
function init(isStorage) {
    if(!isStorage) {
        const Storage = () => {};
        Storage.prototype.setItem = function (id, val) {
            this[id] = JSON.stringify(val);
        };
        Storage.prototype.getItem = function (id) {
            return this.hasOwnProperty(id) ? this[id] : null;
        };
        Storage.prototype.removeItem = function (id) {
            return delete this[id];
        };

        Storage.prototype.clear = function () {
            var self = this;
            Object.keys(this).map(function (key) {
                self.removeItem(key);
            });
        };

        window.localStorage = new Storage();
    }
}

export default function () {
    var isStorage = false;
    try {
        isStorage = 'localStorage' in window && window.localStorage != null;
    } catch (e) {
        // console.log('no storage');
    }
    init(isStorage);
}



// WEBPACK FOOTER //
// ./src/app/utils/localstorage.js